import { BooleanSelect } from './BooleanSelect';
import { CodeFormField } from './CodeFormField';
import { DateFormField } from './DateFormField';
import { DropdownSelect } from './DropdownSelect';
import { EntitySelect } from './EntitySelect';
import { EnumSelect } from './EnumSelect';
import { InstantFormField } from './InstantFormField';
import { MoneyFormField } from './MoneyFormField';
import { NumberFormField } from './NumberFormField';
import { PercentFormField } from './PercentFormField';
import { TextFormField } from './TextFormField';
import { TreeSelect } from './TreeSelect';

export const DynamicFormField = ({ fieldDef }) => {
  const fieldTypeToFormField = {
    NUMBER: NumberFormField,
    BOOLEAN: BooleanSelect,
    ENUM: EnumSelect,
    DATE: DateFormField,
    INSTANT: InstantFormField,
    HYPERLINK: EntitySelect,
    ENTITY_ENUM: EnumSelect,
    MONEY: MoneyFormField,
    DROPDOWN: DropdownSelect,
    TREE: TreeSelect,
    PERCENT: PercentFormField,
  };

  // TextFormField is the default
  let FormFieldComponent = fieldTypeToFormField[fieldDef.type] ?? TextFormField;

  // A self link (code or name) gets a CodeFormField if it is a code for the uniqueness check
  if (fieldDef.type === 'SELF_LINK') {
    FormFieldComponent = fieldDef.field === 'code' ? CodeFormField : TextFormField;
  }

  return <FormFieldComponent id={fieldDef.name} fieldDef={fieldDef} />;
};
